import type { SliderItem } from '@/types/appTypes'

const defaultApiResponse = {
  code: 500000,
  data: null,
  meta: null,
}

export const useStoreArticleSlider = defineStore('articleSlider', () => {
  const nuxtApp = useNuxtApp()
  const kjdsConfig = useAppConfig().kijidas

  function makeSliderItems(article: Article, articleObjects: ArticleObject[]): SliderItem[] {
    let newItems = [] as SliderItem[]
    if (article?.custom) {
      const storeIndex = useStoreIndex()
      for (let i = 1; i <= 10; i++) {
        const imgId = article.custom['slide_image' + i]
        if (imgId) {
          const objVal = storeIndex.findArticleObject(imgId, articleObjects)
          if (objVal) {
            const imgObj = storeIndex.getImgInfo(objVal, 'l')
            const newItem = {
              title: article.custom['slide_title' + i],
              link: article.custom['slide_url' + i],
              image: imgObj,
              type: article.custom['slide_article_type' + i],
              body: article.custom['slide_body' + i],
              rank: article.custom['slide_rank' + i],
              outLink: false,
            }
            if (!newItem.link) {
              newItem.link = '#'
            } else if (newItem.link.indexOf('http') === 0) {
              newItem.outLink = true
            }
            //  順番rankの数字化
            newItem.rank = nuxtApp.$anyToInteger(newItem.rank, 0)
            newItems.push(newItem)
          }
        }
      }
    }
    //  ソートrank高い順
    newItems = newItems.sort((a, b) => {
      return b.rank - a.rank
    })
    return newItems
  }
  async function fetchSlider(slug): Promise<ApiResponse<ApiArticleDetail>> {
    const resData: ApiResponse<ApiArticleDetail> = { ...defaultApiResponse }
    try {
      const res = await nuxtApp.$ApiWithCache(
        () => nuxtApp.$ArticleApi.articleDetailSlug(
          slug,
          kjdsConfig.sliderTypeSlug,
        ),
        { key: `SLIDER_${slug}` },
      )
      if ((res.data as any).code === 200000) {
        return res.data
      }
    } catch (e) {
      return resData
    }

    return resData
  }

  return {
    fetchSlider,
    makeSliderItems,
  }
})
